import { render, staticRenderFns } from "./documentos-diaspora.vue?vue&type=template&id=2ca3f25f&scoped=true&"
import script from "./documentos-diaspora.component.ts?vue&type=script&lang=ts&"
export * from "./documentos-diaspora.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca3f25f",
  null
  
)

export default component.exports